<template>
   <v-row v-if="!mobile" align="center" justify="center" no-gutters class="py-5 accent pt-8">
    <v-col cols="10">
      <div class="title1 white--text text--darken-3 font-weight-bold" align="center" >Confira os últimos posts</div>
      <v-row align="start" justify="center" class="mt-5">
        <v-col v-for="news in news" :key="news.title" cols="12" md="3" sm="6">
          <v-img :src="news.src" class="white--text align-end" height="300px"/>
          <div class="text-left pt-4 white--text">
              {{ news.title }} <a :href="news.link" target="_blank" class="text-uppercase orange--text">Ler mais</a>
          </div>
          <div class="text-left pt-4">
          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row> 
  <v-carousel
    v-else
    hide-delimiters
    :show-arrows="false"
    cycle
    interval="4000"
    height="560px"
    class="accent pt-4"
  >
      <div class="text-h5 white--text text--darken-3 font-weight-bold mb-4" align="center" >Confira os últimos posts</div>
    <v-carousel-item v-for="news in news" :key="news.title" cols="12" sm="3" class="text-center">
      <v-img :src="news.src" class="mx-auto align-end" max-width="400px" max-height="400px"/>
      <div class="text-left pt-4 px-4 text-center white--text">
        {{ news.title }}
        <a :href="news.link" target="_blank" class="text-uppercase orange--text"
          >Ler mais</a>
      </div>
    </v-carousel-item>
  </v-carousel>
</template>
<script>
export default {
  data: () => ({
    news: [
      {
        title:
          "Em breve será lançado o Tesys. o mais novo parceiro do Contadores. Fiquem atentos!",
        data: "17/Junho/2021",
        src: require("@/assets/news/tesys.png"),
        link: "https://www.instagram.com/p/CZfU0seFuFr/",
      },
      {
        title:
          "Buscamos sempre desenvolver soluções práticas, que auxiliam no dia a dia das empresas e dos seus clientes.",
        data: "07/Maio/2021",
        src: require("@/assets/news/almeidatech.png"),
        link: "https://www.instagram.com/p/CZfUKatr7RQ/",
      },
      {
        title:
          "Que tal Testar Gratuitamente o Malha Fina do Contador e ter acesso gratuito às análises de Caixa das suas Declarações de 2011 a 2021?",
        data: "06/Abril/2021",
        src: require("@/assets/news/malha-fina.png"),
        link: "https://www.instagram.com/p/CYkFpNqrAGZ/",
      },
      {
        title:
          "Você ainda utiliza papéis para solicitar Consentimentos? Transforme papeladas e assinaturas em simples cliques.",
        data: "17/Março/2021",
        src: require("@/assets/news/econsenso.png"),
        link: "https://www.instagram.com/p/CXOeKesMBc7/",
      },
    ],
  }),
  methods: {
    selectedCarousel(i, j) {
      var a = i * this.columns - this.columns;
      if (a + j <= 6) return a + j - 1;
      return 0;
    },
  },
  computed: {
    mobile(){
      if (this.$vuetify.breakpoint.smAndDown) return true;
      return false;
    }
  },
};
</script>


<style scoped>
.break {
  word-break: break-word;
}
.title1 {
  font-size: 34px;
}
.subtitle1 {
  font-size: 19px;
}
</style>